import React from 'react';

import {Modal, Button, ProgressBar} from 'react-bootstrap';

import _ from 'lodash';


const MessageModal = (props) => {

  const type=props.type || 'error';
  const title = {
    'error': 'Oops!',
    'info': 'Information',
    'success': 'Voila!!'
  };

  const msgTitle = props.title || title[type];

  const hideHandler = () => {
    props.onHide();    
  }

  console.log(props.message);
  
  return <Modal show onHide={hideHandler} centered>
  <Modal.Header closeButton>
    <Modal.Title>{msgTitle}</Modal.Title>
  </Modal.Header>
  <Modal.Body className="bg-white">
    {_.isArray(props.message) && <ul>
      {props.message.map((e,i) => <li key={i} className="text-dark">{e}</li>)}
    </ul>}
    {_.isObject(props.message) && React.isValidElement(props.message) && <div className="text-dark">{props.message}</div>}
    {_.isString(props.message) && <div className="text-dark">{props.message}</div>}
    {props.dwn && <ProgressBar className="mt-2" animated variant="warning" now={100} />}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={hideHandler}>Close</Button>
  </Modal.Footer>
</Modal>
}

export default MessageModal;